import BaseService from "../BaseService";
import _ from "lodash";

class WebsiteReportService extends BaseService {
    dashboard = async (filter) => {
        var data = await this._api.post("/report/dashboard",filter);
        return data;
    };

   











}
export default WebsiteReportService;
